export default "__VITE_ASSET__CRSmlco6__"